import { Modal } from "antd";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { SpaceHomeMembershipListItem } from "../home/SpaceHomeMembershipListItem";

export function BundlePlanPickerModal(props: {
  open: boolean;
  bundles: MembershipProduct[];
  spaceId: string;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
  onClose: () => void;
  onPickBundle: (bundle: MembershipProduct) => void;
}): JSX.Element {
  const {
    open,
    bundles,
    spaceId,
    isLoggedIn,
    onLoginRequest,
    spaceProfile,
    onClose,
    onPickBundle,
  } = props;
  return (
    <Modal
      title="选择套餐"
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      centered
      destroyOnHidden
      className="space-bundle-plan-picker-modal"
    >
      <ul className="space-membership-list space-bundle-plan-picker-list" aria-label="可选套餐">
        {bundles.map((row) => (
          <SpaceHomeMembershipListItem
            key={row.spaceProductId}
            spaceId={spaceId}
            row={row}
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
            spaceProfile={spaceProfile}
            onSubscribePrimaryClick={() => onPickBundle(row)}
          />
        ))}
      </ul>
    </Modal>
  );
}
